import { createSelector } from 'reselect'
import { ILanguages } from '../types/languages'
import { AppStateType } from '../reducers'

export const selectLanguages = createSelector(
  [(state: AppStateType) => state.languages],
  (languages: ILanguages) => languages
)
